import React from 'react'

export default function NoMatchPage() {
    return (
        <div className='col'>
            <p>Page not found</p>
        </div>
    )
}
